import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import DatePickerProvider from './DatePickerProvider'
import MyDatePicker from './MyDatePicker'
import ErrorBoundary from '../ErrorBoundary'
import moment from 'moment'

export default function Period (props) {
  const disabled = props.disabled

  const [periodFrom, setPeriodFrom] = useState(moment().date(1)) // 当月の1日をデフォルトで指定する
  const [periodTo, setPeriodTo] = useState(moment())

  useEffect(() => {
    // 最初だけ実行
    let mPeriodFrom = moment(props.periodFrom)
    if (!mPeriodFrom.isValid()) {
      mPeriodFrom = moment().date(1) // 当月の1日をデフォルトで指定する
    }
    let mPeriodTo = moment(props.periodTo)
    if (!mPeriodTo.isValid()) {
      mPeriodTo = moment(mPeriodFrom)
      mPeriodTo.add(1, 'years').add(-1, 'days')
    }
    setPeriodFrom(mPeriodFrom)
    setPeriodTo(mPeriodTo)
  }, [])

  return (
    <DatePickerProvider>
      <div className="my-input-root">
        <MyDatePicker
          id="period-from"
          name="period_from"
          label="契約開始日"
          value={periodFrom.format('YYYY-MM-DD')}
          onChange={(date) => {
            if (!disabled) {
              setPeriodFrom(moment(date))
              setPeriodTo(moment(date).add(1, 'years').add(-1, 'days'))
            }
          }}
          readOnly={disabled}
          required={true}
        />
      </div>
      <div className="my-input-root">
        <MyDatePicker
          id="period-to"
          name="period_to"
          label="契約終了日"
          value={periodTo.format('YYYY-MM-DD')}
          onChange={(date) => {
            if (!disabled) {
              setPeriodTo(moment(date))
            }
          }}
          readOnly={disabled}
          required={true}
          minDate={periodFrom.format('YYYY-MM-DD')}
        />
      </div>
    </DatePickerProvider>
  )
}

Period.propTypes = {
  periodFrom: PropTypes.string,
  periodTo: PropTypes.string,
  disabled: PropTypes.bool
}

Period.defaultProps = {
  periodFrom: moment().format('YYYY-MM-DD'),
  periodTo: moment().add(1, 'years').add(-1, 'days').format('YYYY-MM-DD'),
  disabled: false
}

const idList = ['#period-jsx']
idList.map((id) => {
  const elem = $(id)
  if (elem.length) {
    const props = elem.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
    ReactDOM.render(
      <ErrorBoundary>
        <Period {...props}/>
      </ErrorBoundary>,
      elem[0]
    )

    Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
      elem.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
      return 0
    })
  }
  return 0
})
